import React, { useCallback, useState, useEffect, useRef } from "react";
import {
  DataTable,
  Page,
  Card,
  Text,
  ButtonGroup,
  Button,
  Modal,
  TextField,
  Select,
  BlockStack,
  InlineStack,
  Box,
  Spinner,
  FormLayout,
  Image,
  Link,
  Divider,
  Tag,
  Toast,
  TextContainer,
  Icon,
} from "@shopify/polaris";
import axios from "../../Assets/Lib/axios";
import emptyListImage from "../../Assets/Images/emptyList.svg";
import MyPagination from "@material-ui/lab/Pagination";
import { useNavigate } from "react-router-dom";
import {
  CategoriesIcon,
  EditIcon,
  ImagesIcon,
  LinkIcon,
  PlusCircleIcon,
} from "@shopify/polaris-icons";
import countries from "../../Data/countries.json";
import lebanonIcon from "../../Assets/Images/lb.svg";
import iraqIcon from "../../Assets/Images/iq.svg";
import egyptIcon from "../../Assets/Images/eg.svg";
import * as AiIcons from "react-icons/ai";

const Benchmarks = () => {
  const navigate = useNavigate();

  // Filters state
  const [search, setSearch] = useState("");
  const [channel, setChannel] = useState("All");
  const [typeFilter, setTypeFilter] = useState("All");
  const [channelFilter, setChannelFilter] = useState("All");
  const [countryFilter, setCountryFilter] = useState("All");
  const [timeline, setTimeline] = useState("All");
  const timelineButtons = [
    { label: "All", value: "All" },
    { label: "This Week", value: "week" },
    { label: "This Month", value: "month" },
  ];

  // Data state
  const [items, setItems] = useState(null);
  const [result, setResult] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isListEmpty, setIsListEmpty] = useState(false);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const perPage = 50;
  const refBoolPage = useRef(true);
  const [activeShow, setActiveShow] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);

  // Toast
  const [active, setActive] = useState(false);
  const toggleActive = useCallback(() => setActive(!active), []);
  const [toastContent, setToastContent] = useState(
    "This page has been successfully deleted"
  );
  const toastMarkup = active ? (
    <Toast content={toastContent} onDismiss={toggleActive} />
  ) : null;

  // Modal Delete
  const [activeDelete, setActiveDelete] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const refId = useRef(null);

  const handleChangeModalShow = useCallback(() => {
    setActiveShow(!activeShow);
  }, [activeShow]);

  const handleChangeModalDelete = useCallback(() => {
    setActiveDelete(!activeDelete);
    setIsSaving(false);
  }, [activeDelete]);

  const handleRowClick = (id) => {
    navigate(`/admin/benchmarks/${id}/metrics`);
    //setCurrentIndex(index);
    //setActiveShow(true);
  };

  const handleAddItem = () => {
    navigate("/admin/benchmarks/new");
  };

  const handleEdit = (id) => {
    navigate(`/admin/benchmarks/${id}`);
  };

  const handleScreenshots = (id) => {
    navigate(`/admin/benchmarks/${id}/screenshots`);
  };

  const handleNext = () => {
    if (currentIndex < result.length - 1) {
      setCurrentIndex(currentIndex + 1);
    }
  };

  const handlePrevious = () => {
    if (currentIndex > 0) {
      setCurrentIndex(currentIndex - 1);
    }
  };

  const handleChangePage = (event, value) => {
    refBoolPage.current = true;
    setPage(value);
  };
  const [optionsCountries, setOptionsCountries] = useState([]);
  const [country, setCountry] = useState("");

  useEffect(() => {
    fetchData();
  }, [page, search, countryFilter, channelFilter, country]);

  const fetchData = async () => {
    setIsLoading(true);
    try {
      const params = new URLSearchParams();
      params.append("per_page", perPage);
      params.append("page", refBoolPage.current ? page : 1);
      if (search) params.append("filter[name]", search);
      // if (typeFilter !== "All") params.append("filter[type]", typeFilter);
      if (channelFilter !== "All")
        params.append("filter[channel]", channelFilter);
      if (country !== "") params.append("filter[country]", country);
      // if (countryFilter !== "All")
      //   params.append("filter[location]", countryFilter);

      const response = await axios.get(`/benchmark-parents`, { params });
      const data = response.data.data.data;

      console.log("data=", data);
      setResult(data);

      setItems(
        data.map((item, index) => [
          <div
            // className="border border-light rounded overflow-hidden row_click"
            style={{ width: 30, height: 30 }}
            onClick={() => handleRowClick(item.id)}
          >
            {item.icon ? (
              renderIcon(item.icon)
            ) : (
              <img
                src={
                  item.image_url ||
                  "https://cdn.shopify.com/s/files/1/0533/2089/files/placeholder-images-image_large.png"
                }
                alt="logo"
                className="img-fluid w-100 h-100"
                style={{ objectFit: "contain" }}
              />
            )}
          </div>,
          <div onClick={() => handleRowClick(item.id)} className="row_click">
            {item.name || "-"}
          </div>,
          <div onClick={() => handleRowClick(item.id)} className="row_click">
            {item.channel || "-"}
          </div>,

          <div className="me-3">
            <ButtonGroup>
              {/* <Button
                onClick={() => handleScreenshots(item.id)}
                icon={ImagesIcon}
              >
                Screenshots
              </Button> */}
              <Button onClick={() => handleEdit(item.id)} icon={EditIcon}>
                Edit
              </Button>
            </ButtonGroup>
          </div>,
        ])
      );

      setTotalPages(response.data.data.total);
      setIsListEmpty(!data.length);
    } catch (err) {
      console.error(err);
      setIsListEmpty(true);
    }
    setIsLoading(false);
  };

  const emtyState = isListEmpty ? (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <div style={{ width: "25%" }}>
        <img src={emptyListImage} />
      </div>
      <div className="mb-3">
        <Text variant="headingLg" as="h5" color="subdued">
          No results found
        </Text>
      </div>
    </div>
  ) : isLoading ? (
    <div className="spinnerContainer">
      <div className="vertical-center">
        <Spinner size="large" />
      </div>
    </div>
  ) : null;
  const [countryButtons, setCountryButtons] = useState([]);
  useEffect(() => {
    axios
      .get("/settings/countries")
      .then((res) => {
        const countriesData = res?.data?.data || [];
        const options = [
          { label: "All", value: "" },
          { label: "Mutual", value: "All" },
          ...countriesData.map((country) => ({
            label: country.name,
            value: country.name,
            flag: country.flag,
          })),
        ];
        setCountryButtons(options);
        // setCountry(options?.[0]);
      })
      .catch((err) => console.log(err));
  }, []);
  const renderIcon = (iconName) => {
    if (!iconName) return null;

    const IconComponent = AiIcons[iconName];
    if (!IconComponent) return null;

    return <IconComponent size={30} />;
  };

  return items ? (
    <Page
      title="Benchmarks"
      primaryAction={
        <Button variant="primary" onClick={handleAddItem} icon={PlusCircleIcon}>
          Add Benchmark
        </Button>
      }
      secondaryActions={
        <Button
          onClick={() => navigate("/admin/benchmarks/edit/categories")}
          icon={CategoriesIcon}
        >
          Categories
        </Button>
      }
      fullWidth
    >
      {/* Filters Card */}
      <FormLayout>
        <Card>
          <BlockStack gap="500">
            {/* Filters + Country buttons in one row */}
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center", // ✅ centers vertically
                flexWrap: "wrap",
                gap: "1rem",
              }}
            >
              {/* 🔹 Left side: Filters */}
              <InlineStack gap="300" wrap align="center">
                <Box minWidth="260px">
                  <TextField
                    label="Search benchmarks"
                    value={search}
                    onChange={setSearch}
                    autoComplete="off"
                    placeholder="Search by name"
                  />
                </Box>

                <Select
                  label="Channel"
                  value={channelFilter}
                  onChange={setChannelFilter}
                  options={[
                    { label: "All", value: "All" },
                    { label: "Mobile", value: "Mobile" },
                    { label: "Desktop", value: "Desktop" },
                    { label: "Mobile Web", value: "Mobile Web" },
                  ]}
                />
              </InlineStack>

              {/* 🔹 Right side: Country buttons */}
              <div
                style={{
                  display: "flex",
                  alignItems: "center", // ✅ aligns button group with filters
                }}
              >
                <ButtonGroup segmented>
                  {countryButtons.map((t) => (
                    <Button
                      key={t.value}
                      pressed={country === t.value}
                      onClick={() => setCountry(String(t.value))}
                    >
                      {t.flag && (
                        <img
                          src={t.flag}
                          alt={t.label}
                          style={{ width: 20, marginRight: 6 }}
                        />
                      )}
                      {t.label}
                    </Button>
                  ))}
                </ButtonGroup>
              </div>
            </div>
          </BlockStack>
        </Card>

        {/* DataTable */}
        {items?.length ? (
          <Card padding="0">
            <DataTable
              columnContentTypes={["text", "text", "text", "text"]}
              headings={["Image", "Name", "Channel", ""]}
              rows={items}
              verticalAlign="middle"
              stickyHeader
              footerContent={
                items?.length &&
                `Showing ${items.length} of ${totalPages} results`
              }
            />
          </Card>
        ) : (
          <Card>
            <div
              style={{
                display: "flex",
                justifyContent: "middle",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <div style={{ width: "25%" }}>
                <img src={emptyListImage}></img>
              </div>
              <div className="mb-3">
                <Text variant="headingLg" as="h5" color="subdued">
                  No results found
                </Text>
              </div>
              <br />
            </div>
          </Card>
        )}

        {/* Pagination */}
        {Math.ceil(totalPages / perPage) >= 2 && (
          <div
            style={{
              paddingTop: "10px",
              textAlign: "center",
              paddingBottom: "10px",
            }}
          >
            <MyPagination
              count={Math.ceil(totalPages / perPage)}
              page={page}
              onChange={handleChangePage}
              size="large"
            />
          </div>
        )}
      </FormLayout>
      {/* Modals */}
      <Modal
        // size="small"
        open={activeShow}
        onClose={handleChangeModalShow}
        title={result?.[currentIndex]?.business_name ?? ""}
        primaryAction={{
          content: "Next",
          onAction: handleNext,
          disabled: currentIndex === result?.length - 1,
        }}
        secondaryActions={[
          {
            content: "Previous",
            onAction: handlePrevious,
            disabled: currentIndex === 0,
          },
        ]}
      >
        <Modal.Section>
          <div className="fixedModalContent">
            <FormLayout>
              {result?.[currentIndex]?.website ? (
                <FormLayout>
                  <Link
                    monochrome
                    onClick={() =>
                      window.open(result?.[currentIndex]?.website, "_blank")
                    }
                  >
                    {result?.[currentIndex]?.website}
                  </Link>
                  <Divider borderColor="border" />
                </FormLayout>
              ) : null}

              {result?.[currentIndex]?.ios ||
              result?.[currentIndex]?.android ? (
                <FormLayout>
                  <Text as="p" fontWeight="semibold">
                    Mobile apps:
                  </Text>
                  <div
                    className="divCursor"
                    style={{ display: "flex", gap: "8px" }}
                  >
                    {result?.[currentIndex]?.ios && (
                      <div
                        style={{ cursor: "pointer" }}
                        onClick={() =>
                          window.open(result?.[currentIndex]?.ios, "_blank")
                        }
                      >
                        <Tag>iOS</Tag>
                      </div>
                    )}
                    {result?.[currentIndex]?.android && (
                      <div
                        style={{ cursor: "pointer" }}
                        onClick={() =>
                          window.open(result?.[currentIndex]?.android, "_blank")
                        }
                      >
                        <Tag>Android</Tag>
                      </div>
                    )}
                  </div>
                  <Divider borderColor="border" />
                </FormLayout>
              ) : null}
              {result?.[currentIndex]?.location ? (
                <FormLayout>
                  <Text as="p" fontWeight="semibold">
                    Location
                  </Text>
                  <Text>{result?.[currentIndex]?.location}</Text>
                  <Divider borderColor="border" />
                </FormLayout>
              ) : null}
              {result?.[currentIndex]?.type !== null ? (
                <FormLayout>
                  <Text as="p" fontWeight="semibold">
                    Type
                  </Text>
                  <Text>
                    {String(result?.[currentIndex]?.type) === "1"
                      ? "Direct"
                      : "Indirect"}
                  </Text>
                  <Divider borderColor="border" />
                </FormLayout>
              ) : null}
              {result?.[currentIndex]?.facebook ? (
                <FormLayout>
                  <Text as="p" fontWeight="semibold">
                    Facebook
                  </Text>
                  <Text>{result?.[currentIndex]?.facebook}</Text>
                  <Divider borderColor="border" />
                </FormLayout>
              ) : null}
              {result?.[currentIndex]?.instagram ? (
                <FormLayout>
                  <Text as="p" fontWeight="semibold">
                    Instagram
                  </Text>
                  <Text>{result?.[currentIndex]?.instagram}</Text>
                  <Divider borderColor="border" />
                </FormLayout>
              ) : null}
              {result?.[currentIndex]?.tiktok ? (
                <FormLayout>
                  <Text as="p" fontWeight="semibold">
                    Tiktok
                  </Text>
                  <Text>{result?.[currentIndex]?.tiktok}</Text>
                  <Divider borderColor="border" />
                </FormLayout>
              ) : null}
              {result?.[currentIndex]?.facebook_followers !== null ? (
                <FormLayout>
                  <Text as="p" fontWeight="semibold">
                    Facebook Followers
                  </Text>
                  <Text>{result?.[currentIndex]?.facebook_followers}</Text>
                  <Divider borderColor="border" />
                </FormLayout>
              ) : null}

              {result?.[currentIndex]?.insta_followers !== null ? (
                <FormLayout>
                  <Text as="p" fontWeight="semibold">
                    Instagram Followers
                  </Text>
                  <Text>{result?.[currentIndex]?.insta_followers}</Text>
                  <Divider borderColor="border" />
                </FormLayout>
              ) : null}
              {result?.[currentIndex]?.titkok_followers !== null ? (
                <FormLayout>
                  <Text as="p" fontWeight="semibold">
                    Titkok Followers
                  </Text>
                  <Text>{result?.[currentIndex]?.titkok_followers}</Text>
                  <Divider borderColor="border" />
                </FormLayout>
              ) : null}

              {result?.[currentIndex]?.estimated_sales !== null ? (
                <FormLayout>
                  <Text as="p" fontWeight="semibold">
                    Estimated Sales
                  </Text>
                  <Text>{result?.[currentIndex]?.estimated_sales}</Text>
                  <Divider borderColor="border" />
                </FormLayout>
              ) : null}
              {result?.[currentIndex]?.products !== null ? (
                <FormLayout>
                  <Text as="p" fontWeight="semibold">
                    Products
                  </Text>
                  <Text>{result?.[currentIndex]?.products}</Text>
                  <Divider borderColor="border" />
                </FormLayout>
              ) : null}
              {result?.[currentIndex]?.employees !== null ? (
                <FormLayout>
                  <Text as="p" fontWeight="semibold">
                    Employees
                  </Text>
                  <Text>{result?.[currentIndex]?.employees}</Text>
                  <Divider borderColor="border" />
                </FormLayout>
              ) : null}
              {result?.[currentIndex]?.location ? (
                <FormLayout>
                  <Text as="p" fontWeight="semibold">
                    Description
                  </Text>
                  <Text>{result?.[currentIndex]?.description}</Text>
                  <Divider borderColor="border" />
                </FormLayout>
              ) : null}
              {result?.[currentIndex]?.location ? (
                <FormLayout>
                  <Text as="p" fontWeight="semibold">
                    Why Considered Benchmark
                  </Text>
                  <Text>{result?.[currentIndex]?.why_is_benchmark}</Text>
                  <Divider borderColor="border" />
                </FormLayout>
              ) : null}

              {result?.[currentIndex]?.screenshots?.length ? (
                <FormLayout>
                  <Text as="p" fontWeight="semibold">
                    Screenshots
                  </Text>
                  <div style={{ display: "flex", gap: "10px" }}>
                    {result?.[currentIndex]?.screenshots.map((img, index) => (
                      <img
                        key={index}
                        src={img}
                        alt={`image-${index}`}
                        style={{
                          width: "100px", // fixed width
                          height: "100px", // fixed height
                          objectFit: "cover", // maintain aspect ratio, crop if necessary
                          cursor: "pointer", // optional if you want them clickable
                        }}
                        onClick={() => window.open(img, "_blank")}
                      />
                    ))}
                  </div>
                  <Divider borderColor="border" />
                </FormLayout>
              ) : null}

              {/* <Box>
              <Pagination
                hasPrevious={currentIndex > 0}
                onPrevious={handlePrevious}
                hasNext={currentIndex < result?.length - 1}
                onNext={handleNext}
              />
            </Box> */}
            </FormLayout>
          </div>
        </Modal.Section>
      </Modal>

      {toastMarkup}
    </Page>
  ) : (
    <div className="spinnerContainer">
      <div className="vertical-center">
        <Spinner size="large" />
      </div>
    </div>
  );
};

export default Benchmarks;
